<template>
  <el-dialog
          title="团队商家明细"
          :visible.sync="dialogVisible"
          customClass="customWidth"
          @opened="dialogOpen"
  >
    <div class="header" flex="main:justify cross:center">
    <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            size="mini"
            style="margin-bottom: -18px;"
    >

      <el-form-item
      >
        <el-date-picker
                v-model="pickerValue"
                type="daterange"
                align="right"
                size="small"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 300px;"
                value-format="yyyy-MM-dd" format="yyyy-MM-dd">
          ></el-date-picker>
      </el-form-item>

      <el-form-item
      >
        <el-input
                v-model="searchForm.user_agentid"
                placeholder="商家编号"
                style="width: 120px;"
        />
      </el-form-item>


      <el-form-item
      >
        <el-input
                v-model="searchForm.agentname"
                placeholder="商家名称"
                style="width: 120px;"
        />
      </el-form-item>
      <el-form-item
      >
        <el-input
                v-model="searchForm.pingkey"
                placeholder="乐刷编号"
                style="width: 120px;"
        />
      </el-form-item>



      <el-form-item>
        <el-button
                type="primary"
                @click="handleSearchFormSubmit"
        >
          <d2-icon name="search" /> 查询
        </el-button>
      </el-form-item>

      <el-form-item>
        <el-button @click="handleSearchFormReset">
          <d2-icon name="refresh" /> 重置
        </el-button>
      </el-form-item>
    </el-form>
    </div>
    <div class="header2" flex="main:justify cross:center">
    订单总数 {{order_num}}笔； 订单总金额 {{wz_num_bf}}元； 微信总金额 {{wx_num_bf}}元； 支付宝总金额 {{zfb_num_bf}}元； 微信总数 {{yhk_num_bf}}笔； 支付宝总数 {{fyk_num_bf}}笔
    </div>
    <el-table
            :data="tableData"
            v-loading="loading"
            size="small"
            stripe
            highlight-current-row
            style="width: 100%;"
            @selection-change="handleSelectionChange"
            @sort-change="handleSortChange"
    >
      <el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50px">
      </el-table-column>

      <el-table-column
              label="商家编号"
      >
        <template slot-scope="scope">
          {{scope.row.agentid}}
        </template>
      </el-table-column>

      <el-table-column
              label="商户名称"
      >
        <template slot-scope="scope">
          {{scope.row.agentname}}
        </template>
      </el-table-column>
      <el-table-column
              label="商户头像"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.agentlogo!=null && scope.row.agentlogo!=''">
            <img :src= "getImgUrl33(scope.row.agentlogo)" style="width: 100px;height: 100px; "/>
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="乐刷编号"
      >
        <template slot-scope="scope">
          {{scope.row.pingkey}}
        </template>
      </el-table-column>
      <el-table-column
              label="姓名"
      >
        <template slot-scope="scope">
          {{scope.row.legal}}
        </template>
      </el-table-column>
      <el-table-column
              label="省"
      >
        <template slot-scope="scope">
          {{scope.row.province}}
        </template>
      </el-table-column>
      <el-table-column
              label="市"
      >
        <template slot-scope="scope">
          {{scope.row.cityname}}
        </template>
      </el-table-column>
      <el-table-column
              label="区县"
      >
        <template slot-scope="scope">
          {{scope.row.areaname}}
        </template>
      </el-table-column>
      <el-table-column
              label="地址"
      >
        <template slot-scope="scope">
          {{scope.row.compaddress}}
        </template>
      </el-table-column>
      <el-table-column
              label="电话"
      >
        <template slot-scope="scope">
          {{scope.row.shop_tel}}
        </template>
      </el-table-column>
      <el-table-column
              label="创建时间"
      >
        <template slot-scope="scope">
          {{scope.row.create_times}}
        </template>
      </el-table-column>




      <el-table-column
              label="入驻平台总交易金额"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.sales}}
        </template>
      </el-table-column>
      <el-table-column
              label="粉丝"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.fans}}
        </template>
      </el-table-column>
      <el-table-column
              label="级别"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">

          <div v-if="scope.row.level=='1'">
            直推
          </div>
          <div v-else> 间推</div>
        </template>
      </el-table-column>


    </el-table>
    <div style="text-align: center;margin-top: 30px;">
      <el-pagination
              :current-page="page.current"
              :page-size="page.size"
              :total="page.total"
              :page-sizes="[1,10,50,100, 200, 300, 400]"
              layout="total, sizes, prev, pager, next, jumper"
              style="margin: -10px;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

  </el-dialog>

</template>
<style>
  .customWidth{
    width:90%;
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js'
    export default {
        name: "threeagentEditForm",
        props: {
            agentid: String,
            value: Boolean
        },
        data() {
            return {
              wz_num_bf:'0',
              order_num:'0',
              wx_num_bf:'0',
              zfb_num_bf:'0',
              yhk_num_bf:'0',
              fyk_num_bf:'0',
                loading: false,
                dialogVisible: false,
                tableData: [],
                pickerValue: [],

                searchForm: {
                  user_agentid:"",
                  pingkey:"",
                  agentname:""
                },
                page: {
                    current: 1,
                    size: 10,
                    total: 0
                },
                sort: {
                    prop: "",
                    order: ""
                }
            };
        },
        watch: {
            value(val) {
                this.dialogVisible = val;
            },
            dialogVisible(val) {
                this.$emit("input", val);
            }
        },
        methods: {
            dateConversion(value){
                var d = new Date(value);
                //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
                var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
                console.info("===========date========="+date);
                return date;
            },
            dialogOpen() {
                this.$refs.searchForm.resetFields();
                this.getTableData33();
                this.getTableDataMx();

            },
            getTableDataMx() {
                var formData4 = new FormData() // 声明一个FormData对象
                formData4.append("agentid",this.agentid);
                if(this.pickerValue!=null) {
                    formData4.append("start_time", this.pickerValue[0]);
                    formData4.append("end_time", this.pickerValue[1]);
                    console.info("pay_type======" + this.pickerValue[0]);
                }
                formData4.append("agentname",this.searchForm.agentname);
              formData4.append("user_agentid",this.searchForm.user_agentid);
              formData4.append("pingkey",this.searchForm.pingkey);

                agentService.getStatistiSales(formData4).then(data => {
                    if(data!=null && data!=""){
                        this.wz_num_bf=data.wz_num_bf;
                        this.order_num=data.order_num;
                        this.wx_num_bf=data.wx_num_bf;
                        this.zfb_num_bf=data.zfb_num_bf;
                        this.yhk_num_bf=data.yhk_num_bf;
                      this.fyk_num_bf=data.fyk_num_bf;

                    }
                });

                //

            },
            getTableData33() {
              if(this.pickerValue==null){
                this.pickerValue="";
              }
                console.info("===========ddddddddd========="+this.pickerValue[0]);
                let query = {
                    pageIndex: this.page.current,
                    pageSize: this.page.size,
                    sortBy: this.sort.prop,
                    agentid: this.agentid,
                    start_time:this.pickerValue[0],
                    end_time:this.pickerValue[1],
                    descending: this.sort.order === "descending",
                    filter: this.searchForm
                };
                agentService.getMobileOrderPagelistSales(query).then(data => {
                    this.tableData = data.rows;
                    this.page.total = data.totalCount;
                });
            },
            handleSearchFormSubmit() {
                this.getTableData33();
                this.getTableDataMx();
            },
            handleSearchFormReset() {
                this.$refs.searchForm.resetFields();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handleSortChange(val) {
                this.sort.prop = val.prop;
                this.sort.order = val.order;
                this.getTableData33();
            },
            handleSizeChange(val) {
                this.page.size = val;
                this.getTableData33();
            },
            handleCurrentChange(val) {
                this.page.current = val;
                this.getTableData33();
            },
          getImgUrl33(url){
            return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+url;
          },
            close() {
                this.$refs["searchForm"].resetFields();
                this.dialogVisible = false;
            }
        }
    };
</script>
<style lang="scss" scoped>
  .header {
    font-size: 12px;
    padding: 20px;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  .header2 {
    font-size: 12px;
    padding: 20px;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
</style>
